import {Component, Inject, OnInit, Optional} from '@angular/core';
import {Serializer} from '../../interfaces/serializer';

@Component({
  selector: 'app-cell-sources',
  templateUrl: './cell-sources.component.html',
  styleUrls: ['./cell-sources.component.scss']
})
export class CellSourcesComponent implements OnInit {

  public item: Serializer<any>

  constructor(
    @Optional() @Inject('agGridParams') public readonly agGridParams
  ) { }

  ngOnInit(): void {
    this.item = this.agGridParams.row.payload || this.agGridParams.row;
  }

}
